import { followingSidebar } from '../../utils/sidebar.utils.js';

const articleSection = document.querySelector('.article-sec');

if (articleSection && window.innerWidth > 1024) {
  const sidebar = articleSection.querySelector('.article-sec__aside');

  if (sidebar) {
    followingSidebar({
      sidebar,
      sidebarInnerSelector: '.article-sec__aside-inner',
      gap: 24,
    });
  }
}
